import type { EditorViewState } from 'owa-editor';
import { callEditorApi } from 'owa-editor/lib/utils/callApi';

export interface EditorSelectionCache {
    range: Range;
    restorer: () => void;
}

/**
 * Cache current selection range of HTML editor, if any. Returns the range a restorer function.
 * Call this restorer function to restore the selection if editor is still valid.
 * @param viewState ViewState of the HTML editor
 */
export default function cacheEditorSelection(viewState: EditorViewState): EditorSelectionCache {
    const range = callEditorApi(viewState, 'getSelectionRange');
    const restorer = range
        ? () => {
              callEditorApi(viewState, 'focus');
              callEditorApi(viewState, 'select', range as any);
          }
        : () => {};

    return { range, restorer };
}
